"use strict";

angular.module("core")
.component("paymentMethodFilter", {
    bindings: {
        filter: "<?",
        url: "@"
    },
    templateUrl: require("./payment-method-filter.component.html"),
    controllerAs: "paymentMethodFilterCtrl",
    controller: function($scope, $stateParams, $resource, ConvertToParameterService, appConfig) {
        var _this = this;
        var resource = $resource(appConfig.API_SERVER + _this.url, {}, {
            query: {
                method: "get",
                isArray: true,
                ignoreLoadingBar: true
            }
        });
        this.selectedMethods = {};

        function query() {
            var filterParams = _this.filter ? _this.filter : {};
            resource.query(filterParams).$promise.then(function onSuccess(methodFilters) {
                _this.methodFilters = methodFilters;
                if ($stateParams.method) {
                    var methodParams = $stateParams.method.split(",");

                    angular.forEach(methodFilters, function(value) {
                        if (methodParams.indexOf(value.key) >= 0) {
                            _this.selectedMethods[value.key] = value.key;
                        }
                    });
                }
            });
        }

        this.updateMethodFilter = function() {
            var selectedMethods = ConvertToParameterService.convertValuesToParameter(this.selectedMethods);
            $scope.$emit("paymentMethodFilterUpdated", {method: selectedMethods});
        };

        query();

        $scope.$on("resetListing", function() {
            query();
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-method-filter/payment-method-filter.component.js
// module id = 643
// module chunks = 0